import {apiPost,apiGet} from "./apiUtils";
import { getLoggedInUserTenantID } from "./sessionUtil";

var tasks = 
[
    {
        "taskName": "Order Entry",
        "description": "Entering order into our order entry system",
        "priority": 'P1',
        "userCount": '10',
        "costperhour":40,
        "endDate":"7/30/2021",
        "status": "CLOSED",
    },
    {
        "taskName": "Order Review",
        "description": "Review order",
        "priority": 'P2',
        "userCount": '20',
        "costperhour":50,
        "endDate":"8/30/2021",
        "status": "ACTIVE"
    },
    {
        "taskName": "Billing",
        "description": "Billing for order",
        "priority": 'P0',
        "userCount": '30',
        "costperhour":70,
        "endDate":"9/30/2021",
        "status": "ACTIVE"
    }

 
]
;

export function getTasks() {
      
    let tenantId = getLoggedInUserTenantID();
    let url = `${process.env.REACT_APP_API_PREFIX}/task/getTasksByTenantId/${tenantId}`;
    return apiGet(url);
 
 }

 export function getTasksForProcessId(processId) {
      
    let tenantId = getLoggedInUserTenantID();
    let url = `${process.env.REACT_APP_API_PREFIX}/task/getTasksByTenantIdAndProcessId/tenant/${tenantId}/process/${processId}`;
    return apiGet(url);
 
 }



 export async function addTask(task, processId){
    console.log("Adding task "+JSON.stringify(task));
    let url = `${process.env.REACT_APP_API_PREFIX}/task/createTask`;
    task.tenantId = getLoggedInUserTenantID();
    task.processId = processId
    return apiPost(url,task);    
 }

 export function updateTask(task){

    task.tenantId = getLoggedInUserTenantID();
    let url = `${process.env.REACT_APP_API_PREFIX}/task/updateTask`;
    return apiPost(url,task);
 }

 export function deleteTask(task){
    console.log("Deleting task " + JSON.stringify(task))
    task.tenantId = getLoggedInUserTenantID();
    let url = `${process.env.REACT_APP_API_PREFIX}/task/deleteTask`;
    return apiPost(url,task);

 }

 export function getTaskGroups(){
    const taskGroups =["Admin","Designer","Deployer","APICaller","Attended"];
    return new Promise(function (resolve,reject){
        resolve(taskGroups);

    }) ;
 
 }

 export function sendSubmissionsRequestEmails(task, emails){

    let url = `${process.env.REACT_APP_API_PREFIX}/processdiscovery/initiateTaskNotification`;
    let requestBody = {
      tenantId:getLoggedInUserTenantID(),
      taskId:task.taskId,
      taskName:task.taskName,
      userList:emails
    }

    apiPost(url,requestBody);
 }


 